import { addEventListeners, onHover } from "../../../helpers/events";
export const initLabel = (column) => {
    column.getElement().querySelectorAll('select[data-label="update"]').forEach((select) => {
        select.addEventListener('change', () => {
            let labelSetting = column.getElement().querySelector('input.ac-setting-input_label');
            let option = select.selectedOptions.length > 0 ? select.selectedOptions[0] : null;
            if (labelSetting && option) {
                labelSetting.value = option.innerHTML;
                labelSetting.dispatchEvent(new Event('change'));
            }
        });
    });
    setTimeout(() => {
        column.getElement().querySelectorAll('[data-column-label]').forEach(el => {
            if (el.offsetWidth < 10) {
                el.innerText = column.getType();
            }
        });
    }, 50);
};
export const initLabelSettingEvents = (column) => {
    let labelInput = column.getElement().querySelector('.ac-column-setting--label input');
    if (labelInput) {
        addEventListeners(labelInput, ['change', 'keyup'], () => changeLabel(labelInput, column));
    }
};
export const initLabelTooltipsEvent = (column) => {
    column.getElement().querySelectorAll('.col-label .label').forEach(label => {
        onHover(label, () => hoverTooltip(label, 'block'), () => hoverTooltip(label, 'none'));
    });
};
const hoverTooltip = (label, display) => {
    let related = label.closest('.col-label').querySelector('div.tooltip');
    if (related) {
        related.style.display = display;
    }
};
const changeLabel = (labelInput, column) => {
    column.getElement().querySelectorAll('[data-column-label]').forEach(el => el.innerHTML = labelInput.value);
};
